<template>
    <div class="eventscenter">
        <div class="bg">
            <div class="tit">
                {{ meg.title }}
            </div>
            <div class="time">
                {{ meg.words }} · {{ meg.month }}{{ meg.year }}
            </div>
            <div class="photo">
                <img v-lazy=meg.newsImg alt="" style="width: 84.533vw;height: 53.333vw;;border-radius: 10px;">
            </div>
        </div>
        <div class="wrap">
                <div v-html="meg.content ? meg.content : ''"></div>
            <el-divider></el-divider>
            <div style="font-size: 6.4vw;font-weight: bold;color: #000;">Recommended Post</div>
            <div class="other">
                <div class="others" v-for="item in meg.news" :key="item.id">
                    <div @click="detail(item.id)">
                     <img v-lazy="item.newsImg" alt="" style="width: 84.267vw;height: 53.067vw;border-radius: 10px;">
                    <div class="othertitle">
                        {{ item.title }}
                    </div>   
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            meg: [],
        }
    },
    activated() {
        this.getdetails()
    },
    methods: {
        getdetails() {
            this.$axios
                .post("/api/mall/newsDetailed/detailed", {
                    parentId: this.$route.query.id
                })
                .then(res => {
                    if (res.data.code === 200) {
                        this.meg = res.data.data
                    } else {
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        detail(id) {
            this.$router.push({
                path: '/eventscenter',
                query: {
                    id: id
                }
            })
            this.getdetails()
        },
    }
}
</script>

<style scoped>
.eventscenter{
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}
.bg {
    height: 168px;
    padding-top: 21px;
    background-color: #7A060B;
    position: relative;
    margin-bottom: 140px;
}

.tit {
    color: #FFF;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
}

.time {
    margin-top: 7px;
    color: #FFF;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
}

.photo {
    width: 317px;
    height: 200px;
    position: absolute;
    top: 190px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.wrap {
    padding: 0 29px;
}

.other {
    margin: 21px 0 37px;
}
.others{
    width: 317px;
    height: 251px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
}
.othertitle{
    margin-top: 17px;
    color: #333;
    display: flex;
    justify-content: center;
}
</style>